"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var owa_options_store_1 = require("owa-options-store");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styling_1 = require("@uifabric/styling");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var SubCategoryEntry = mobx_react_1.observer(function (props) {
    var buttonStyles = {
        root: className(styles.option, {
            selectedOption: owa_options_store_1.getStore().currentSubCategoryKey === props.subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };
    return (React.createElement(Button_1.BaseButton, { styles: buttonStyles, key: props.subcategory.key, onClick: function () { return owa_options_orchestration_1.selectSubcategory(props.subcategory); }, text: owa_options_strings_1.default[props.subcategory.titleStringKey] }));
});
var SubCategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(SubCategoriesColumn, _super);
    function SubCategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubCategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.optionsColumn },
            React.createElement(FocusZone_1.FocusZone, { direction: FocusZone_1.FocusZoneDirection.vertical, key: owa_options_store_1.getStore().currentCategoryKey, className: styling_1.AnimationClassNames.slideLeftIn20 }, this.props.subcategories.map(function (subcategory) { return (React.createElement(SubCategoryEntry, { subcategory: subcategory, key: subcategory.key })); }))));
    };
    SubCategoriesColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], SubCategoriesColumn);
    return SubCategoriesColumn;
}(React.Component));
exports.default = SubCategoriesColumn;
//# sourceMappingURL=SubCategoriesColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/SubCategoriesColumn.js
// module id = 5311
// module chunks = 2